// PO1-3488: quem criou a cotação (criadoPor { nome, email, em } da API).

const pad2 = (n) => String(n).padStart(2, "0");

// Nome para exibir: o nome do cadastro; sem ele, a parte antes do @.
export function nomeCriadoPor(criadoPor) {
  if (!criadoPor) return "";
  if (criadoPor.nome) return String(criadoPor.nome).trim();
  const email = String(criadoPor.email || "");
  return email.split("@")[0] || "";
}

// Primeiro nome, para a linha da listagem ("Laercio Cabral" -> "Laercio";
// "laercio.cabral" -> "laercio").
export function primeiroNomeCriadoPor(criadoPor) {
  const nome = nomeCriadoPor(criadoPor);
  return nome.split(/[\s.]+/)[0] || nome;
}

// Tooltip: "Laercio Cabral <laercio.cabral@arneg.com.br>".
export function tituloCriadoPor(criadoPor) {
  if (!criadoPor) return "";
  const nome = nomeCriadoPor(criadoPor);
  return criadoPor.email && criadoPor.nome ? `${nome} <${criadoPor.email}>` : nome || criadoPor.email || "";
}

// "Criado por Laercio Cabral em 16/10/2026 10:10" (hora do navegador).
export function textoCriadoPor(criadoPor) {
  const nome = nomeCriadoPor(criadoPor);
  if (!nome) return "";
  const d = criadoPor.em ? new Date(criadoPor.em) : null;
  const quando =
    d && Number.isFinite(d.getTime())
      ? ` em ${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`
      : "";
  return `Criado por ${nome}${quando}`;
}
